import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url:'https://landlords.bremertonwa.gov/rest.php',
    url2:"https://ipn.paymentus.com/rotp/cbrl",
	url3:'https://arcgis.bremertonwa.gov/arcgis/rest/services/Basemaps/Simple_Basemap/MapServer/0/query',
    Auth:'no',
    username:'',
    account:'',
    email:'',
    addressinfo:[],
    accountinfo:[],
    sc:[],
    urlhistory:'',
  },
  mutations: {
    setUrlHistory(state,x){
      state.urlhistory=x;
    },
    setAuth(state,Authvalue){
      state.Auth=Authvalue;
    },
    setUsername(state,username){
      state.username=username;
    },
    setacem(state,{a,e}){
      state.account=a;
      state.email=e;
    },
    setaccountinfo(state,x){
      state.accountinfo=x;
    },
    setaddressinfo(state,x){
      state.addressinfo=x;
    },
    setscinfo(state,x){
      state.sc=x;
    },
  },
  actions: {
  },
  modules: {
  }
})
